import { useEffect } from 'react';
export function useScript(props) {
  useEffect(() => {
    const head = document.querySelector('head');
    if (!head) return;
    const script = document.createElement('script');
    Object.assign(script, props);
    head.appendChild(script);
    return () => {
      head.removeChild(script);
    };
  }, [props]);
}
//# sourceMappingURL=useScript.js.map